<template>
  <div class="help d-flex flex-column align-self-center">
    <p class="help-mobile">{{ $t("help.horizontal_mobile") }}</p>
    <p class="help-desktop">{{ $t("help.horizontal_desktop") }}</p>
    <div class="help-image">&nbsp;</div>
    <p class="help-mobile">{{ $t("help.vertical_mobile") }}</p>
    <p class="help-desktop">{{ $t("help.vertical_desktop") }}</p>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
  .help {
    margin-top: 70px;
    position: relative;
    max-width: 600px;
    width: 100%;
    @media (max-width: 576px) {
      margin-top: 46px;
    }
    h3 {
      display:none;
      margin: 24px 0 16px 0;
    }
    p {
      text-align: center;
      @media (max-width: 768px) {
        padding: 0 24px;
      }
    }
    .help-image {
      width: 100%;
      height: 190px;
      background-image: url("~@/assets/placeholders/help-desktop.svg");
      background-repeat: no-repeat;
      background-position: center;
      margin: 20px 0 32px 0;
      @media (max-width: 768px) {
        background-image: url("~@/assets/placeholders/help-mobile.svg");
      }
    }
    @media (max-width: 768px) {
      .help-mobile {
        display: block;
      }
      .help-desktop {
        display: none;
      }
    }
    @media (min-width: 768px) {
      .help-mobile {
        display: none;
      }
      .help-desktop {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/help.vue